<!-- Why Di 360 -->
<section class="why_di_sec">
  <!-- master_heading -->
  <!-- <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100" fxFlexFill>
      <div class="master_heading text-center">
        <h2>Why Di 360 ?</h2>
        <p>DI 360 Is A Unique Platform Developed To Cater To The Needs Of The Dental Community.</p>
      </div>
    </div>
  </div> -->
  <section class="why_di_bg">
    <div class="wrapper">
      <div class="why_di_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
        fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
        <div class="why_di_column" fxLayout="column" fxFlex.xl="70" fxFlex.lg="70" fxFlex.md="70" fxFlex.sm="70"
          fxFlex.xs="100" fxFlexFill>
          <div class="row-wrap advantage_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
            fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start stretch">
            <div class="advantage_column" fxLayout="column" fxFlex.xl="33" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="50"
              fxFlex.xs="100" fxFlexFill>
              <div class="why_di_box">
                <div class="img_box">
                  <img src="../../../../../assets/images/advantages/1.svg" alt="">
                </div>
                <div class="why_content">
                  <h4>Get Dental Equipment On The Go</h4>
                </div>
              </div>
            </div>
            <div class="advantage_column" fxLayout="column" fxFlex.xl="33" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="50"
              fxFlex.xs="100" fxFlexFill>
              <div class="why_di_box">
                <div class="img_box">
                  <img src="../../../../../assets/images/advantages/2.svg" alt="">
                </div>
                <div class="why_content">
                  <h4>Sell Your Residual Dental Equipment Easily</h4>
                </div>
              </div>
            </div>
            <div class="advantage_column" fxLayout="column" fxFlex.xl="33" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="50"
              fxFlex.xs="100" fxFlexFill>
              <div class="why_di_box">
                <div class="img_box">
                  <img src="../../../../../assets/images/advantages/3.svg" alt="">
                </div>
                <div class="why_content">
                  <h4>List Your Clinic or Business To Our Directory Listing</h4>
                </div>
              </div>
            </div>
            <div class="advantage_column" fxLayout="column" fxFlex.xl="33" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="50"
              fxFlex.xs="100" fxFlexFill>
              <div class="why_di_box">
                <div class="img_box">
                  <img src="../../../../../assets/images/advantages/4.svg" alt="">
                </div>
                <div class="why_content">
                  <h4>Learn From Or Educate The Dental Community</h4>
                </div>
              </div>
            </div>
            <div class="advantage_column" fxLayout="column" fxFlex.xl="33" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="50"
              fxFlex.xs="100" fxFlexFill>
              <div class="why_di_box">
                <div class="img_box">
                  <img src="../../../../../assets/images/advantages/5.svg" alt="">
                </div>
                <div class="why_content">
                  <h4>Sell Your Dental Practice Easily</h4>
                </div>
              </div>
            </div>
            <div class="advantage_column" fxLayout="column" fxFlex.xl="33" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="50"
              fxFlex.xs="100" fxFlexFill>
              <div class="why_di_box">
                <div class="img_box">
                  <img src="../../../../../assets/images/advantages/6.svg" alt="">
                </div>
                <div class="why_content">
                  <h4>Book Appointments With Clinics or Suppliers</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="why_di_column" fxLayout="column" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="30"
          fxFlex.xs="100" fxFlexFill>
          <div class="advantages_right">
            <div class="w-100">
              <h2>Advantages</h2>
              <h3>One platform for everything dental !</h3>
              <p>With this idea, we have tried to provide every kind of service that a dental practice owner or a
                dentist, or a dental supplies & equipment provider might require to make their life easy and productive.
              </p>
              <!-- <button class="btn btn-sm global-btn" mat-button>Learn More</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</section>
